import Signature from "../entities/Signature";
export const isSyncData = (data) => {
    return data.syncId !== undefined;
};
export const SYNC_CHECKPOINT_INTERVAL = 100;
//# sourceMappingURL=Synchronisation.js.map